// css
import "./offerDetail.css";
//
import { useEffect, useState } from "react";
import axios from "axios";

//============= other ================
import logo from "assets/Images/icons/newLogo1.png";
import { ChevronRight, ChevronLeft } from "@material-ui/icons";
import { useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";
import Loader from "Components/others/Loader";
import { Slide, Fade } from "react-reveal";

// SWiper slider config
SwiperCore.use([Pagination, Navigation, Autoplay]);

// api endpoints
let api_all_offers = process.env.REACT_APP_ALL_INCLUSIVE_OFFERS;
let api_domain = process.env.REACT_APP_API_DOMAIN;

//================== Location Icons svg ======================
let LocationImg = () => {
  return (
    <svg width="24" height="30" viewBox="0 0 24 30" fill="none">
      <path
        d="M12.2 16.3922C14.5196 16.3922 16.4 14.5118 16.4 12.1922C16.4 9.87259 14.5196 7.99219 12.2 7.99219C9.8804 7.99219 8 9.87259 8 12.1922C8 14.5118 9.8804 16.3922 12.2 16.3922Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2 0.992188C9.22957 0.992188 6.38081 2.17218 4.2804 4.27259C2.18 6.373 1 9.22176 1 12.1922C1 14.841 1.5628 16.5742 3.1 18.4922L12.2 28.9922L21.3 18.4922C22.8372 16.5742 23.4 14.841 23.4 12.1922C23.4 9.22176 22.22 6.373 20.1196 4.27259C18.0192 2.17218 15.1704 0.992188 12.2 0.992188V0.992188Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
//=================== Check Icons svg ====================
let CheckIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
        fill="#00EE76"
      />
    </svg>
  );
};

//===================== Check Icons svg ========================
// let CancelIcon = () => {
//     return (
//         <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
//             <path d="M15.1992 15.8195C15.3455 15.5901 16.5316 13.8991 15.8861 13.6444C14.8408 13.6258 13.8201 13.6865 12.8595 13.1801C11.5921 12.513 10.6505 11.6025 9.70859 10.5309C9.45436 10.2423 9.45964 9.87638 9.70859 9.58651C11.2124 7.72109 13.0013 6.40328 14.883 4.80312C15.7305 4.05023 14.3186 2.73216 13.2831 2.6378C12.8125 2.6378 12.3422 2.92013 11.8709 3.10836C10.1769 4.14384 9.14141 5.74424 7.84292 7.12881C7.69761 7.30549 7.49057 7.35318 7.2923 7.31578C7.09379 7.27889 6.90406 7.15692 6.79414 6.99405C6.0691 5.91716 5.40881 4.76749 4.95457 3.54704C4.71138 2.89529 4.48376 2.235 4.32013 1.5579C4.07719 0.543999 3.70878 1.09612 3.28565 1.64247C2.1292 3.13471 1.69027 4.27961 2.70592 6.04941C3.45405 7.35343 4.25914 8.59972 5.18319 9.78578C5.35536 10.0071 5.47733 10.3349 5.28734 10.5949C4.86874 11.1683 4.35275 11.8854 3.75345 12.5421C3.55457 12.7617 3.34527 12.9715 3.12629 13.171C2.26899 14.1214 0.480615 14.0273 0.198029 14.8748C-0.177916 15.6277 1.1394 16.9448 2.40777 16.9902C2.64177 16.9709 2.8722 16.9208 3.09316 16.8414C4.65667 16.2903 5.95265 14.4161 6.86767 13.2232C7.11412 12.9013 7.59798 12.7369 7.91595 13.088C9.12334 14.4203 10.5222 16.2353 12.3374 16.7413C13.4989 17.0648 14.5178 16.8913 15.1979 15.8187" fill="#F43249" />
//             <path d="M1.58511 14.8748C1.8677 14.0273 3.65607 14.122 4.51337 13.171C4.73146 12.9733 4.94001 12.7615 5.14053 12.5421C5.73933 11.8854 6.25582 11.1683 6.67393 10.5949C6.86441 10.3351 6.74194 10.0071 6.57003 9.78578C5.64648 8.59972 4.84013 7.35368 4.0925 6.04941C3.15189 4.41036 3.45907 3.30762 4.42804 1.96822C4.38995 1.83201 4.35398 1.69522 4.32013 1.5579C4.07719 0.543999 3.70878 1.09612 3.28565 1.64247C2.1292 3.13471 1.69027 4.27961 2.70592 6.04941C3.45405 7.35343 4.25914 8.59972 5.18319 9.78578C5.35536 10.0071 5.47733 10.3349 5.28734 10.5949C4.86874 11.1683 4.35275 11.8854 3.75345 12.5421C3.55457 12.7617 3.34527 12.9715 3.12629 13.171C2.26899 14.1214 0.480615 14.0273 0.198029 14.8748C-0.177916 15.6277 1.1394 16.9448 2.40777 16.9902C2.63969 16.9706 2.86811 16.9212 3.08739 16.8432C2.09231 16.4717 1.27919 15.4862 1.58511 14.8748Z" fill="#F43249" />
//         </svg>
//     )
// };

// THIS IS A ALL OFFER DETAIL PAGE
const AllOfferDetail = () => {
  const [offerDetails, setOfferDetails] = useState({
    boat_pictures: [],
    general_pictures: [],
    activities_pictures: [],
    transfer_pictures: [],
    itinerary: [],
    extras: [],
    amenities: [],
  });
  const [loaded, setLoaded] = useState(false);
  const [errorDisplayMsg, setDisplayErrorMsg] = useState(false);
  //================== navigation buttons Ref for top slider ==================
  // const navigationPrevRef = useRef(null);
  // const navigationNextRef = useRef(null);
  //================= navigation buttons Ref for Motorboat Azimut 62 slider ===================
  const motorNavigationPrevRef = useRef(null);
  const motorNavigationNextRef = useRef(null);

  //=================== getting offer id from params/url =====================
  let { id } = useParams();

  //==================== islands list data ======================
  // let islandList = [
  //     { name: "TINOS", img: LocationImg },
  //     { name: "MYKONOS", img: LocationImg },
  //     { name: "SANTORINI", img: LocationImg },
  //     { name: "CRETE", img: LocationImg },
  //     { name: "PAROS", img: LocationImg },
  // ];

  //============== package include offers list ===================
  // let includes = [
  //     'SUP',
  //     'Yacht Slide',
  //     'Jetski',
  //     'SUP',
  //     'Yacht Slide',
  //     'Jetski',
  //     'Kayak',
  //     'Yacht Golf',
  //     'Yoga session',
  //     'Kayak',
  //     'Yacht Golf',
  //     'Yoga session',
  // ];
  //================ package not include offers list ==================
  // let NotIncludes = [
  //     'Stario',
  //     'Ice Cream',
  //     'Break Fast',
  //     'Tennis',
  //     'Fishing',
  //     'Diving',
  // ];

  useEffect(() => {
    const get_data = () => {
      if (id?.toString()?.length > 0) {
        let url = api_all_offers + id?.toString();
        axios
          .get(url, {
            headers: {
              "Content-Type": "multipart/form-data",
              // 'Authorization': `Token ${userToken}`
            },
          })
          .then((response) => {
            setLoaded(true);
            let data = response?.data;
            if (data?.status !== "error") {
              setOfferDetails(data?.offer);
            }
          })
          .catch((err) => {
            console.log("Error ====>", err.message);
            setDisplayErrorMsg(true);
          });
      }
    };
    get_data();
    return () => {
      get_data();
    };
  }, [id]);
  // ===========
  let apiStart = api_domain;
  // console.log("===>",offerDetails)

  // go to the section
  const scrollTo_Section = (sec_id) => {
    let element = document.getElementById(sec_id);
    // const yOffset = -127;
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  //=================== check if offer id is available or not  ===================
  if (id?.toString()?.length > 0) {
    return loaded ? (
      <div className="allofferDetail">
        {/* =============================================== */}
        <div className="offer_detail_sec1 d-flex flex-wrap">
          {/* <div className="cs_container"> */}
          {/* <div className="row m-0"> */}
          <div className="offer-detail-pg-top-left d-flex flex-column">
            <Slide top>
              <header className="py-3">
                <div className="logo">
                  <Link to="/">
                    <img src={logo} alt="" />
                  </Link>
                </div>
              </header>
            </Slide>
            <div className="offer_detail_hero_content overflow-hidden">
              <Slide left>
                <h1>{offerDetails?.title}</h1>
              </Slide>
              <Slide bottom>
                <h3 className="my-md-5 my-3 py-md-3 py-0">
                  {offerDetails?.duration +
                    (parseInt(offerDetails?.duration) > 1 ? " Days" : " Day")}
                </h3>
                <p className="text-white text-center fw-light mt-3 mb-md-5 mb-3 pb-md-4">
                  {offerDetails?.brief_description}
                </p>
                <Link
                  to={"/confirmBooking/" + id}
                  className="cs-btn py-2 px-3 avail-offer-btn-all-offers text-white"
                >
                  Reserve
                </Link>
              </Slide>
            </div>
            <div className="mt-auto w-100 text-white d-flex flex-column justify-content-center align-items-center py-3 text-center mx-auto">
              <Slide bottom>
                {/* <p className="m-0">{offerDetails?.location}</p> */}
                <p
                  className="m-0 cursor-pointer user-select-none"
                  onClick={() => scrollTo_Section("start")}
                >
                  Scroll for more
                </p>
                <ChevronLeft
                  className="text-white rotate-down cursor-pointer user-select-none"
                  onClick={() => scrollTo_Section("start")}
                />
              </Slide>
            </div>
          </div>
          <Fade right>
            <div
              className="offer-detail-pg-top-right"
              style={{
                backgroundImage: `url(${
                  apiStart + offerDetails?.general_pictures[0]
                })`,
              }}
            >
              <img
                src={apiStart + offerDetails?.general_pictures[0]}
                alt="cyan"
              />
            </div>
          </Fade>
          {/* <div className="col-md-6  col-12 p-0"> */}
          {/* <Swiper
                                    className="offer-detail"
                                    navigation={{
                                        prevEl: navigationPrevRef.current,
                                        nextEl: navigationNextRef.current,
                                    }}
                                    speed={500}
                                    grabCursor
                                    loop={true}
                                    onBeforeInit={(swiper) => {
                                        swiper.params.navigation.prevEl = navigationPrevRef.current;
                                        swiper.params.navigation.nextEl = navigationNextRef.current;
                                    }
                                    }>
                                    {offerDetails?.general_pictures?.map((v, i) => (
                                        <SwiperSlide key={i} className="offer-detail-slider-card">
                                            <img
                                                className="offer-slider-img"
                                                src={apiStart + v}
                                                alt="cyan"
                                            />
                                        </SwiperSlide>
                                    ))}
                                    <div className="offer-detail-slider-cs-navs_wrapper">
                                        <div ref={navigationPrevRef} className="offer-detail-slider-cs-nav prev-bt">
                                            <ChevronLeft />
                                        </div>
                                        <div ref={navigationNextRef} className="offer-detail-slider-cs-nav next-bt">
                                            <ChevronRight />
                                        </div>
                                    </div>
                                </Swiper> */}
          {/* <img
                                    className="offer_detail_main_img"
                                    src={apiStart + offerDetails?.general_pictures[0]}
                                    alt="cyan"
                                /> */}
          {/* </div> */}
          {/* </div> */}
          {/* </div> */}
        </div>
        {/* ================================================= */}
        <div className="offerDetail_islands">
          <div id="start" className="cs_container  py-md-5 py-3">
            <Slide top>
              <div className="our-story-head center-head-line">
                <h2 className="text-white">Your itinerary</h2>
              </div>
            </Slide>
            <Slide bottom cascade>
              <div className="row py-md-4 justify-content-sm-center justify-content-between  px-md-3 px-2 align-items-center">
                {offerDetails?.itinerary?.map((land, i) => {
                  return land?.trim()?.length > 0 ? (
                    <div
                      key={i}
                      className="offer_placeCard d-flex justify-content-center align-items-center"
                    >
                      <span className="offerDetail_location_logo">
                        <LocationImg />
                      </span>
                      <p>{land}</p>
                    </div>
                  ) : null;
                })}
              </div>
            </Slide>
          </div>
        </div>
        {/* ============================================================= */}
        <section>
          <div className="cs_container my-md-5 my-3 py-md-5 py-3">
            <div className="row justify-content-center align-items-center">
              <div className="col-12 mb-3 text-center">
                <Slide left>
                  <h2 className="text-pr  text-decoration-underline">
                    {offerDetails?.boat_title}
                  </h2>
                </Slide>
              </div>
              <div className="col-md-6 my-3 col-12 text-center">
                <div className="motor-detail-slider">
                  <Swiper
                    navigation={{
                      prevEl: motorNavigationPrevRef.current,
                      nextEl: motorNavigationNextRef.current,
                    }}
                    speed={500}
                    grabCursor
                    loop={true}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl =
                        motorNavigationPrevRef.current;
                      swiper.params.navigation.nextEl =
                        motorNavigationNextRef.current;
                    }}
                  >
                    {offerDetails?.boat_pictures.map((v, i) => (
                      <SwiperSlide key={i} className="motor-detail-slider-card">
                        <Fade>
                          <img
                            className="motor-slider-img"
                            src={apiStart + v}
                            alt="cyan"
                          />
                        </Fade>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className="motor-detail-slider-cs-navs_wrapper d-flex align-items-center">
                    <div
                      ref={motorNavigationPrevRef}
                      className="motor-detail-slider-cs-nav prev-bt"
                    >
                      <ChevronLeft />
                    </div>
                    <div
                      ref={motorNavigationNextRef}
                      className="motor-detail-slider-cs-nav next-bt"
                    >
                      <ChevronRight />
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-sec overflow-hidden col-md-5 col-12 d-flex flex-column justify-content-center align-items-center">
                <Slide bottom>
                  <div className="my-3 py-md-2 row px-sm-3 px-1 justify-content-center m-0">
                    {/*  */}
                    <div className="col-6 p-0 charter_column  d-flex align-items-center text-sec">
                      <span>
                        {parseInt(offerDetails?.num_of_people) > 1 ? "Guests" : "Guest"}
                      </span>
                      <span>
                        <svg
                          width="29"
                          height="29"
                          viewBox="0 0 23 22"
                          fill="none"
                        >
                          <path
                            d="M16.7541 3.62148C17.7541 3.62148 18.5648 2.81078 18.5648 1.81074C18.5648 0.810696 17.7541 0 16.7541 0C15.7541 0 14.9434 0.810696 14.9434 1.81074C14.9434 2.81078 15.7541 3.62148 16.7541 3.62148Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M22.8996 15.3526C22.8996 15.0473 22.6521 14.7998 22.3468 14.7998H21.6353V13.3227C21.8348 13.1396 21.9473 12.8674 21.9136 12.5779L21.1706 6.20088C21.1357 5.09193 20.22 4.19873 19.1041 4.19873H16.7551C16.7548 4.19873 16.7545 4.19878 16.7542 4.19878C16.7539 4.19878 16.7536 4.19873 16.7533 4.19873H14.4044C13.9468 4.19873 13.523 4.34912 13.1797 4.60277C13.4939 5.0765 13.6789 5.64282 13.6819 6.25111L13.6989 9.61831C14.1095 6.0943 14.0838 6.33515 14.0842 6.26466C14.0847 6.16902 14.1624 6.09191 14.258 6.09216C14.3536 6.09241 14.4309 6.16997 14.4309 6.2655C14.431 7.66096 14.4313 13.1567 14.4313 13.2692C15.057 13.4698 15.5114 14.0569 15.5114 14.7484V20.4002C15.5114 20.9099 15.2646 21.3631 14.8842 21.6465C14.8789 21.6972 14.8706 21.747 14.8601 21.796C15.0338 21.9236 15.2476 22 15.4797 22C16.0587 22 16.5281 21.5306 16.5281 20.9515V12.5716H16.9808V20.9517C16.9808 21.5308 17.4502 22.0002 18.0292 22.0002C18.6082 22.0002 19.0776 21.5308 19.0776 20.9517L19.0592 6.38344C19.059 6.28482 19.1358 6.20322 19.2343 6.1974C19.3328 6.19157 19.4188 6.26351 19.4301 6.36148L20.178 12.7801C20.2146 13.0941 20.4136 13.3491 20.6811 13.4723V14.7998H19.9696C19.6644 14.7998 19.4169 15.0473 19.4169 15.3526V20.64C19.4169 20.9453 19.6644 21.1927 19.9696 21.1927H22.3468C22.6521 21.1927 22.8996 20.9453 22.8996 20.64V15.3526Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M2.26068 4.08813L2.4261 2.49997C2.43656 2.39941 2.36358 2.30945 2.26302 2.29895L0.475972 2.11281C0.375411 2.10236 0.285454 2.17534 0.27495 2.2759L0.000996618 4.90601C-0.00945771 5.00657 0.0635235 5.09653 0.164084 5.10703L0.346189 5.126C0.463427 4.8732 0.639756 4.64341 0.873535 4.45981C1.24845 4.1653 1.74259 4.0153 2.26068 4.08813Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M8.30976 3.62148C9.30755 3.62148 10.1205 2.81142 10.1205 1.81074C10.1205 0.810709 9.30979 0 8.30976 0C7.30973 0 6.49902 0.810709 6.49902 1.81074C6.49902 2.8145 7.31486 3.62148 8.30976 3.62148Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M14.5565 14.7486C14.5565 14.4177 14.2882 14.1495 13.9573 14.1495H13.2989V12.6192C13.2989 12.3987 13.1201 12.2199 12.8995 12.2199H12.757L12.7522 11.2657L12.727 6.25594C12.7213 5.12155 11.7938 4.19873 10.6594 4.19873C10.5632 4.19873 8.12301 4.19873 5.95976 4.19873C5.08383 4.19873 4.33172 4.74923 4.03163 5.52225C3.86645 5.94779 3.89229 6.23553 3.88955 6.78528L2.584 5.18642C2.27884 4.8127 1.72844 4.75699 1.35467 5.06226C0.990315 5.35976 0.929332 5.88989 1.20926 6.26266C1.21648 6.27227 1.22285 6.28218 1.23052 6.29154L4.07429 9.77432C4.30897 10.0617 4.69707 10.1676 5.04231 10.0454C5.38985 9.92258 5.62288 9.59476 5.62472 9.22612C5.62621 8.92961 5.63811 6.56061 5.63961 6.26476C5.6401 6.16912 5.71786 6.09201 5.8134 6.09226C5.90898 6.09251 5.98624 6.17007 5.98624 6.26565C5.98624 7.56861 5.98624 12.2561 5.98624 12.5716H5.98664C5.98664 12.7226 5.98664 20.708 5.98664 20.9517C5.98664 21.5307 6.45604 22.0001 7.03506 22.0001C7.61408 22.0001 8.08348 21.5307 8.08348 20.9517V12.5716H8.53615V13.8664C8.76311 13.5387 9.11268 13.302 9.51806 13.2236C9.51806 12.5465 9.51756 12.6213 9.51926 12.5716C9.54146 11.9346 10.0056 11.4084 10.614 11.2906C10.614 10.8072 10.614 7.40209 10.614 6.25251C10.614 6.1515 10.6959 6.06961 10.7969 6.06961C10.8979 6.06961 10.9798 6.15145 10.9798 6.25246C10.9798 6.25649 10.9798 6.26062 10.9797 6.26476L10.9799 6.30359L11.0048 11.2658L11.0096 12.2199H10.8716C10.6511 12.2199 10.4722 12.3987 10.4722 12.6193V14.1495H9.81382C9.48297 14.1495 9.21469 14.4177 9.21469 14.7486V20.4004C9.21469 20.7313 9.48292 20.9995 9.81382 20.9995H9.83413V21.4967C9.83413 21.7602 10.0477 21.9737 10.3112 21.9737C10.5747 21.9737 10.7883 21.7601 10.7883 21.4967V20.9995H12.9828V21.4967C12.9828 21.7602 13.1964 21.9737 13.4599 21.9737C13.7234 21.9737 13.937 21.7601 13.937 21.4967V20.9995H13.9573C14.2882 20.9995 14.5564 20.7313 14.5564 20.4004V14.7486H14.5565ZM12.5002 14.1495H11.2709V13.2998C11.4288 13.4561 11.646 13.5527 11.8855 13.5527C11.887 13.5527 11.8885 13.5527 11.89 13.5527C12.1282 13.5515 12.3434 13.4548 12.5002 13.2994V14.1495H12.5002Z"
                            fill="#3F8BBF"
                          />
                        </svg>
                      </span>
                      <span>{offerDetails?.num_of_people}</span>
                    </div>
                    {/*  */}
                    <div className="col-6 p-0 charter_column  d-flex align-items-center text-sec">
                      <span>
                        {parseInt(offerDetails?.boat_bathrooms) > 1 ? "Bathrooms" : "Bathroom"}
                      </span>
                      <span>
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <rect width="32" height="32" fill="#1A4D6D" />
                          <path
                            d="M30.9841 1.01577C30.874 0.905581 30.7212 0.842285 30.5655 0.842285H1.4339C1.27818 0.842285 1.12542 0.905581 1.01528 1.01577C0.905152 1.1259 0.841797 1.27867 0.841797 1.43439V7.1186C0.841797 7.44485 1.10765 7.71071 1.4339 7.71071C1.76015 7.71071 2.02601 7.44485 2.02601 7.1186V2.0265H29.9734V29.9739H7.71022V13.2765C7.71022 8.70568 11.4289 4.98702 15.9997 4.98702C20.5705 4.98702 24.2892 8.70568 24.2892 13.2765C24.2892 13.6035 24.5543 13.8686 24.8813 13.8686C25.2083 13.8686 25.4734 13.6035 25.4734 13.2765C25.4734 8.05265 21.2235 3.80281 15.9997 3.80281C10.7759 3.80281 6.52601 8.05265 6.52601 13.2765V29.9739H2.02601V12.4475C2.02601 12.1212 1.76015 11.8554 1.4339 11.8554C1.10765 11.8554 0.841797 12.1212 0.841797 12.4475V30.566C0.841797 30.7217 0.905152 30.8745 1.01528 30.9845C1.12542 31.0947 1.27818 31.1581 1.4339 31.1581H30.5655C30.7212 31.1581 30.874 31.0947 30.9841 30.9845C31.0942 30.8745 31.1576 30.7217 31.1576 30.566V1.43439C31.1576 1.27867 31.0942 1.1259 30.9841 1.01577Z"
                            fill="white"
                          />
                          <path
                            d="M1.4339 10.3756C1.76015 10.3756 2.02601 10.1098 2.02601 9.78351C2.02601 9.4572 1.76015 9.19141 1.4339 9.19141C1.10765 9.19141 0.841797 9.4572 0.841797 9.78351C0.841797 10.1098 1.10765 10.3756 1.4339 10.3756Z"
                            fill="white"
                          />
                          <path
                            d="M24.8812 27.29C24.5549 27.29 24.2891 27.5552 24.2891 27.8821C24.2891 28.2084 24.5549 28.4742 24.8812 28.4742C25.2074 28.4742 25.4733 28.2084 25.4733 27.8821C25.4733 27.5552 25.2074 27.29 24.8812 27.29Z"
                            fill="white"
                          />
                          <path
                            d="M25.4733 18.4871C25.4733 18.1608 25.2074 17.895 24.8812 17.895C24.5549 17.895 24.2891 18.1608 24.2891 18.4871V25.2176C24.2891 25.5438 24.5549 25.8091 24.8812 25.8091C25.2074 25.8091 25.4733 25.5438 25.4733 25.2176V18.4871Z"
                            fill="white"
                          />
                          <path
                            d="M24.8812 15.231C24.5549 15.231 24.2891 15.4968 24.2891 15.8231C24.2891 16.1493 24.5549 16.4152 24.8812 16.4152C25.2074 16.4152 25.4733 16.1493 25.4733 15.8231C25.4733 15.4968 25.2074 15.231 24.8812 15.231Z"
                            fill="white"
                          />
                          <path
                            d="M19.5525 11.8559C19.5525 9.89693 17.9588 8.30322 15.9999 8.30322C14.041 8.30322 12.4473 9.89693 12.4473 11.8559C12.4473 13.8148 14.041 15.4085 15.9999 15.4085C17.9588 15.4085 19.5525 13.8148 19.5525 11.8559ZM13.6315 11.8559C13.6315 10.5499 14.6939 9.48743 15.9999 9.48743C17.3058 9.48743 18.3683 10.5499 18.3683 11.8559C18.3683 13.1618 17.3058 14.2243 15.9999 14.2243C14.6939 14.2243 13.6315 13.1618 13.6315 11.8559Z"
                            fill="white"
                          />
                          <path
                            d="M15.6445 18.9612C15.6445 18.6343 15.3794 18.3691 15.0524 18.3691H10.6708C9.69139 18.3691 8.89453 19.166 8.89453 20.1455C8.89453 21.1249 9.69139 21.9218 10.6708 21.9218C11.6503 21.9218 12.4472 21.1249 12.4472 20.1455C12.4472 19.9379 12.411 19.7387 12.3453 19.5534H15.0524C15.3794 19.5534 15.6445 19.2882 15.6445 18.9612ZM10.6708 20.7376C10.3444 20.7376 10.0787 20.4719 10.0787 20.1455C10.0787 19.819 10.3444 19.5534 10.6708 19.5534C10.9973 19.5534 11.263 19.819 11.263 20.1455C11.263 20.4719 10.9973 20.7376 10.6708 20.7376Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      <span>
                        {offerDetails?.boat_bathrooms}
                      </span>
                    </div>
                    {/*  */}
                    <div className="col-6 p-0 charter_column  d-flex align-items-center text-sec">
                      <span>
                        {parseInt(offerDetails?.boat_beds) > 1 ? "Beds" : "Bed"}
                      </span>
                      <span>
                        <svg
                          width="26"
                          height="22"
                          viewBox="0 0 26 22"
                          fill="none"
                        >
                          <path
                            d="M6.23241 4.7627C6.10676 4.7627 6.00488 4.86457 6.00488 4.99023V6.43667H10.7603V4.99017C10.7603 4.86452 10.6585 4.7627 10.5328 4.7627H6.23241Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M15.2002 4.7627C15.0745 4.7627 14.9727 4.86457 14.9727 4.99023V6.43667H19.7281V4.99023C19.7281 4.86457 19.6262 4.76275 19.5006 4.76275H15.2002V4.7627Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M4.48264 6.42154V4.98997C4.48264 4.02482 5.26786 3.23959 6.23301 3.23959H10.5334C11.4986 3.23959 12.2838 4.02482 12.2838 4.98997V6.42154H13.4504V4.98997C13.4504 4.02482 14.2356 3.23959 15.2008 3.23959H19.5012C20.4663 3.23959 21.2515 4.02482 21.2515 4.98997V6.42154H22.4636C22.7 6.42154 22.9309 6.44551 23.1541 6.49095V1.81993C23.1541 0.814824 22.3393 0 21.3343 0H4.39996C3.39485 0 2.58008 0.814824 2.58008 1.81993V6.49095C2.80329 6.44556 3.03423 6.42154 3.27066 6.42154H4.48264Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M24.7899 11.1411H0.943542C0.42244 11.1411 0 11.5636 0 12.0847V18.269C0 18.7901 0.42244 19.2125 0.943542 19.2125H24.7899C25.311 19.2125 25.7334 18.7901 25.7334 18.269V12.0847C25.7334 11.5636 25.311 11.1411 24.7899 11.1411Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M22.4633 7.94434H3.27038C2.2901 7.94434 1.4805 8.67311 1.35254 9.61831H24.3812C24.2532 8.67311 23.4436 7.94434 22.4633 7.94434Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M0.943359 20.7354V21.2384C0.943359 21.6589 1.28428 21.9999 1.70481 21.9999C2.12534 21.9999 2.46625 21.6589 2.46625 21.2384V20.7354H0.943912C0.943711 20.7354 0.94356 20.7354 0.943359 20.7354Z"
                            fill="#3F8BBF"
                          />
                          <path
                            d="M23.2676 20.7354V21.2384C23.2676 21.6589 23.6085 21.9999 24.029 21.9999C24.4496 21.9999 24.7905 21.6589 24.7905 21.2384V20.7354C24.7903 20.7354 24.7901 20.7354 24.7899 20.7354H23.2676V20.7354Z"
                            fill="#3F8BBF"
                          />
                        </svg>
                      </span>
                      <span>{offerDetails?.boat_beds}</span>
                    </div>
                    {/*  */}
                    <div className="col-6 p-0 charter_column  d-flex align-items-center text-sec">
                      <span>Length</span>
                      <span>
                        <svg
                          width="33"
                          height="15"
                          viewBox="0 0 33 15"
                          fill="none"
                        >
                          <path
                            d="M29.2294 14.0479L29.1319 8.21573L23.2302 14.1481L23.1467 9.14882L9.14864 9.38262L9.23214 14.3819L3.13557 8.64994L3.23298 14.4821L0.233398 14.5322L-0.000404738 0.534179L2.99918 0.484079L3.09659 6.31627L8.99834 0.383877L9.08184 5.38318L23.0799 5.14938L22.9964 0.150074L29.093 5.88206L28.9956 0.0498726L31.9951 -0.000228047L32.2289 13.9978L29.2294 14.0479Z"
                            fill="#1A4D6D"
                          />
                        </svg>
                      </span>
                      <span>{offerDetails?.boat_length}m</span>
                    </div>
                  </div>
                </Slide>
                <Slide bottom>
                  <p className="mb-3 text-center mx-auto fw-light px-2">
                    {offerDetails?.boat_description}
                  </p>
                </Slide>
              </div>
            </div>
          </div>
        </section>
        {/*  =========================================*/}
        <section className="bg-light-blue">
          <div className="cs_container py-md-5 py-4 text-center">
            <Slide bottom>
              <div className="our-story-head center-head-line mb-md-2 mb-1">
                <h2 className="">Description of the trip</h2>
              </div>
            </Slide>
            <Slide bottom>
              <p className="text-pr">
                More details are provided upon correspondence
              </p>
              <p className="text-white fw-light pt-md-3 pt-2 col-md-8 col-sm-10 col-11 mx-auto">
                {offerDetails?.general_description}
              </p>
            </Slide>
          </div>
        </section>
        {/* ======================================== */}
        <section className="bg_lenear">
          <div className="cs_container my-md-5 my-3 py-md-5 py-3">
            <Slide bottom>
              <div className="our-story-head center-head-line mb-md-4 mb-1">
                <h2 className="text-white">What you can do</h2>
              </div>
            </Slide>
            <div className="row my-md-3 my-1 justify-content-center align-items-center">
              <div className="text-white overflow-hidden text-center col-md-5 col-12 d-flex flex-column justify-content-center align-items-center">
                <Slide left>
                  <h2 className="text-decoration-underline">
                    {offerDetails?.activities_titles?.[0]}
                  </h2>
                </Slide>
                <Slide bottom>
                  <p className="my-3 fw-light px-2">
                    {offerDetails?.activities_descriptions?.[0]}
                  </p>
                </Slide>
              </div>
              <div className="col-md-6 col-12 text-center">
                <Fade>
                  <div className="motor-detail-slider">
                    <div className="motor-detail-slider-card">
                      <img
                        className="motor-slider-img img_hover mx-img"
                        src={apiStart + offerDetails?.activities_pictures?.[0]}
                        alt="cyan"
                      />
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="row mt-5 flex-md-row-reverse pt-5 justify-content-center align-items-center">
              <div className="text-white overflow-hidden text-center col-md-5 col-12 d-flex flex-column justify-content-center align-items-center">
                <Slide left>
                  <h2 className="text-decoration-underline">
                    {offerDetails?.activities_titles?.[1]}
                  </h2>
                </Slide>
                <Slide bottom>
                  <p className="my-3 fw-light px-2">
                    {offerDetails?.activities_descriptions?.[1]}
                  </p>
                </Slide>
              </div>
              <div className="col-md-6 col-12 text-center">
                <Fade>
                  <div className="motor-detail-slider">
                    <div className="motor-detail-slider-card">
                      <img
                        className="motor-slider-img img_hover"
                        src={apiStart + offerDetails?.activities_pictures?.[1]}
                        alt="cyan"
                      />
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>
        {/* ======================================= */}
        <section>
          <div className="cs_container my-md-5 my-2 py-md-5 py-3">
            <Slide bottom cascade>
              <div className="our-story-head center-head-line mb-md-4 mb-1">
                <h2 className="text-pr mx-auto my-1 p-0">
                  What you will also get
                </h2>
                <span className="text-sec  fw-bold">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                      fill="#92B9D5"
                    />
                  </svg>{" "}
                  Included
                </span>
              </div>
            </Slide>
            <div className="row my-md-3 my-1 justify-content-center align-items-center">
              <div className="text-pr mt-md-0 mt-5 text-center col-md-5 col-12 d-flex flex-column justify-content-center align-items-center">
                <Slide left>
                  <h2>{offerDetails?.transfer_title}</h2>
                </Slide>
                <Slide bottom>
                  <p className="my-3 fw-light px-2">
                    {offerDetails?.transfer_description}
                  </p>
                </Slide>
              </div>
              <div className="col-md-6 p-0 col-12 text-center">
                <Fade>
                  <div className="motor-detail-slider">
                    <div className="motor-detail-slider-card">
                      <img
                        className="motor-slider-img"
                        src={apiStart + offerDetails?.transfer_pictures?.[0]}
                        alt="cyan"
                      />
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>
        {/* =================== =======================*/}
        <section className="book_know_bg">
          <div className="cs_container my-md-5 my-2 py-md-5 py-3">
            <Slide bottom>
              <div className="our-story-head center-head-line mb-md-4 mb-1">
                <h2 className="text-pr mx-auto my-1 p-0 break_heading">
                  Book now and Start your journey
                </h2>
              </div>
            </Slide>
            <div className="offer_detail_extras_wrapper overflow-hidden">
              <Slide left>
                <h5 className="text-pr">Included</h5>
              </Slide>
              <Slide right>
                <div className="col-4 p-0">
                  <hr className="my-1 opacity-25" />
                </div>
              </Slide>
              <Slide bottom>
                <h6 className="text-gr my-2 mt-3">Amenities</h6>
              </Slide>
              <Slide bottom cascade>
                <div className="row m-0">
                  {offerDetails?.amenities?.map((v, i) => {
                    return (
                      <div key={i} className="col-lg-2 col-md-3 col-4 d-flex">
                        <CheckIcon />
                        &nbsp; {v}
                      </div>
                    );
                  })}
                </div>
              </Slide>
              <Slide left>
                <h6 className="text-gr my-2 mt-3">Extras</h6>
              </Slide>
              <Slide bottom>
                <div className="row">
                  {offerDetails?.extras?.map((v, i) => {
                    return (
                      <div key={i} className="col-lg-2 col-md-3 col-4 d-flex">
                        <CheckIcon />
                        &nbsp; {v}
                      </div>
                    );
                  })}
                </div>
              </Slide>
            </div>
            <div className="row m-0">
              {/* <div className="w-100 bg-pr my-3">
                                <hr className="bg-pr opacity-1" />
                            </div>
                            <h5 className="text-pr my-2 mt-3 text-decoration-line-through">
                                Not Included
                            </h5>
                            <div className="row m-0">
                                {NotIncludes.map((v, i) => {
                                    return (
                                        <div className="col-lg-2 col-md-3 col-4 d-flex">
                                            <CancelIcon />&nbsp; {v}
                                        </div>
                                    )
                                })}
                            </div> */}
            </div>
            <div className="w-100 text-center">
              <Slide bottom>
                <Link
                  to={"/confirmBooking/" + id}
                  className="cs-btn avail-offer-btn-all-offers px-5 my-md-5 my-3"
                >
                  Reserve
                </Link>
              </Slide>
            </div>
          </div>
        </section>
      </div>
    ) : (
      <div className="row my-5 py-5">
        {!errorDisplayMsg ? (
          <Slide bottom>
            <Loader />
          </Slide>
        ) : (
          <div className="col-12 text-center mx-auto my-2">
            <Slide cascade bottom>
              <h2 className="text-pr">Offer is not Available.</h2>
              <p className="py-3">Go Back and try different yachts.</p>
              <Link
                to="/allOffers"
                className="mt-3 cs-btn avail-offer-btn-all-offers"
              >
                View All Offers
              </Link>
            </Slide>
          </div>
        )}
      </div>
    );
  } else {
    // else
    return (
      <div className="header-spacer">
        <div className="container">
          <div className="row py-5 my-5">
            <Slide cascade bottom>
              <div className="col-12 text-center mx-auto my-2">
                <h2 className="text-pr">Offer Id could not find.</h2>
                <p className="py-3">Go Back and try different yachts.</p>
                <Link
                  to="/allOffers"
                  className="mt-3 cs-btn avail-offer-btn-all-offers"
                >
                  View All Offers
                </Link>
              </div>
            </Slide>
          </div>
        </div>
      </div>
    );
  }
};

export default AllOfferDetail;
